<template>
  <ol v-if="hasBreadcrumbs" class="breadcrumb breadcrumb-inline pull-right">
    <li v-if="customer !== null" class="breadcrumb-item active">
      <a :href="customer.link">{{ customer.full_name }}</a>
    </li>
    <li v-if="category !== null" class="breadcrumb-item active">{{ category.name }}</li>
    <li v-if="instance !== null" class="breadcrumb-item active">{{ instance.name }}</li>
    <li v-if="attachableCategory !== null" class="breadcrumb-item active">{{ attachableCategory.name }}</li>
  </ol>
</template>

<script>
import store from '../store';

export default {
  name: "AttachableBreadcrumbs",
  props: {
    attachableClass: {
      type: String,
      required: false,
      default: null
    },
    attachableId: {
      type: Number,
      required: false,
      default: null
    },
    breadcrumbs: {
      type: Object,
      required: false,
      default: null
    }
  },
  components: {},
  data() {
    return {
      breadcrumbsValue: null,
    }
  },
  created() {
    const STORE_KEY = '$_attachable';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    this.initBreadcrumbs();
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbsValue !== null;
    },
    instance() {
      if (this.hasBreadcrumbs) {
        return this.breadcrumbsValue.instance;
      }
      return null;
    },
    customer() {
      if (this.hasBreadcrumbs) {
        return this.breadcrumbsValue.customer;
      }
      return null;
    },
    category() {
      if (this.hasBreadcrumbs) {
        return this.breadcrumbsValue.category;
      }
      return null;
    },
    attachableCategory() {
      if (this.hasBreadcrumbs) {
        return this.breadcrumbsValue.attachable_category;
      }
      return null;
    },
  },
  methods: {
    hasCustomer() {
      return this.customer !== null && this.category !== null;
    },
    initBreadcrumbs() {
      if (this.breadcrumbs === null) {
        // attachableApi.breadcrumbs(this.attachableClass, this.attachableId).then((response) => {
        //   this.breadcrumbsValue = response.data;
        //   this.instance = response.data.instance;
        //   this.customer = response.data.customer;
        //   this.category = response.data.category;
        //   this.attachableCategory = response.data.attachableCategory;
        // }).catch(() => {
        //   this.$notification['error']({
        //     message: 'Er ging iets mis',
        //     description: 'Het is niet gelukt om breadcrumbs te laden',
        //   });
        // });
      } else {
        this.breadcrumbsValue = this.breadcrumbs;
      }
    },
  },
  mounted() {
  }
}
</script>